import axiosInstance from "@/plugins/HTTP";
import authHeader from "./auth-header";

class settingService {
  getRefreshToken() {
    return axiosInstance.get("refresh-token", {
      headers: authHeader(),
    });
  }

  getIpBundleDropdown() {
    return axiosInstance.get("get-ip-bundle-dropdown", {
      headers: authHeader(),
    });
  }

  getSettings() {
    return axiosInstance.get("settings", {
      headers: authHeader(),
    });
  }

  saveAppConfig(form) {
    return axiosInstance.post("app-config-save", form, {
      headers: authHeader(),
    });
  }

  updatePannelSetting(id, form) {
    return axiosInstance.post("update-panel-setting/" + id, form, {
      headers: authHeader(),
    })
  }

  getRatePlanList() {
    return axiosInstance.get("rate-plan", {
      headers: authHeader(),
    });
  }

  getRatePlanDetails() {
    return axiosInstance.get("rate-plan-details", {
      headers: authHeader(),
    });
  }

  getAdminInfo() {
    return axiosInstance.get("get-admin-info", {
      headers: authHeader(),
    });
  }

  changeAdminProfileInfo(form) {
    return axiosInstance.post("change-admin-profile-info", form, {
      headers: authHeader(),
    });
  }
}

export default new settingService();
